import {useHistory} from "react-router-dom";

const Helper = () => {
    let history = useHistory();


    const setUiParams = (uiParams) =>{
        if(uiParams && uiParams.payload && uiParams.payload.data && uiParams.payload.data.uiParameters){
            localStorage.clear();
            const item = uiParams.payload.data.uiParameters;
            if(item.main){
                localStorage.setItem("main",JSON.stringify(item.main));
            }
            if(item.offer){
                localStorage.setItem("offer",JSON.stringify(item.offer));
            }
            if(item.receipt){
                localStorage.setItem("receipt",JSON.stringify(item.receipt));
            }
            if(item.header){
                localStorage.setItem("header", JSON.stringify(item.header));
            }
            if(item.buttonColor){
                localStorage.setItem("buttonColor",item.buttonColor);
            }
            if(item.buttonColor2){
                localStorage.setItem("buttonColor2",item.buttonColor2);
            }
            if(item.buttonFontColor){
                localStorage.setItem("buttonFontColor",item.buttonFontColor);
            }
            if(item.orderEnable){
                localStorage.setItem("orderEnable",item.orderEnable);
            }
        }
    }

    const getStorageItem=(item)=>{
        const json= localStorage.getItem(item);
        let itemVal;
        if(json)
            itemVal = JSON.parse(json);
        return itemVal;
    }

    const getStorageItemAsValue=(item)=>{
        return localStorage.getItem(item);
    }


    const getButtonStyle = () => {
      const buttonColor = localStorage.getItem('buttonColor');
      const buttonColor2 = localStorage.getItem('buttonColor2');
      const buttonFontColor = localStorage.getItem('buttonFontColor');
      return {
        backgroundImage: `linear-gradient(to right, ${buttonColor} 1%, ${buttonColor2} 100%)`,
        color: `${buttonFontColor}`,
      };
    };

    const getTrackingId=() =>{
        const urlParams = new URLSearchParams(window.location.search);
        const idParam = urlParams.get('id');

        let trackingId = '0';
        if (idParam !== null && idParam !== '') {
            trackingId = idParam;
        }
        return trackingId;
    }

    const isExternalSdk = () => {
        return getTrackingId() !== '0';
    }

    const redirectToNotFoundPage = () => {
        history.push("/not-found");
    };


    const checkSession = async(result) =>{
        return new Promise(resolve => {
            if (result && result.resultCode && result.resultCode === 'App404') {
                redirectToNotFoundPage();
            }else {
                resolve(true);
            };
        });
    }



    return { setUiParams,getButtonStyle,getTrackingId,isExternalSdk,getStorageItem,checkSession,getStorageItemAsValue};
};

export default Helper;
